<template>
  <div :class="ultimaPergunta ? 'ultima-pergunta-wrapper' : 'pergunta-wrapper'">
    <div v-if="!ultimaPergunta" :class="['pergunta-card', classCssPergunta]">
      <h3>{{ perguntaAtual.ds_pergunta }}</h3>
      <div v-if="perguntaAtual.ds_instrucao" class="pergunta-card-instrucao">
        <p>
          {{ textoInstrucao }}
        </p>
      </div>
    </div>

    <div
      v-else
      class="ultima-pergunta d-flex flex-column justify-content-center align-items-center gap-2 mb-2"
    >
      <div class="icone-pergunta">
        <i class="mdi mdi-check-decagram"></i>
      </div>
      <div class="conteudo">
        <h3 class="titulo text-uppercase font-size-20">
          {{ perguntaAtual.ds_pergunta }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script lang="js">
export default {
  name: "CabecalhoPergunta",

  props: {
    perguntaAtual: {
      type: Object,
      required: true
    }
  },

  computed: {
    textoInstrucao() {
      return (this.perguntaAtual?.ds_instrucao || '')
        .replace(/<br\s*\/?>/gi, '\n')
    },

    classCssPergunta() {
      return this.perguntaAtual?.cd_pergunta === 1 ? 'pergunta-inicial' : '';
    },

    ultimaPergunta() {
      return this.perguntaAtual?.ultima_pergunta;
    }
  }
};
</script>

<style lang="scss" scoped>
.pergunta-wrapper {
  background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);
}

.ultima-pergunta-wrapper {
  background: none;
}

.icone-pergunta {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  border-radius: 50px;
  background: #e3fce1;
  justify-content: center;
  border: 2px solid #005312;
}

.icone-pergunta i {
  color: #005312;
  font-size: 35px;
}

.pergunta-card {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 5px;
  padding: 20px 22px;
  background: #f4f7fb;
  border-radius: 14px;
  margin-bottom: 16px;
}

.pergunta-card h3 {
  margin: 0;
  color: #13345a;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
}

.ultima-pergunta h3 {
  margin: 0;
  color: #13345a;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
}

.pergunta-card-instrucao {
  font-size: 14px;
  color: #38506e;
  line-height: 1.7;
}

.pergunta-card-instrucao p {
  white-space: pre-line;
}

.pergunta-inicial {
  min-height: 350px;
}

@media (max-width: 576px) {
  .pergunta-card {
    padding: 15px 15px;
  }

  .pergunta-card h3 {
    font-size: 14px;
  }

  .pergunta-card-instrucao {
    line-height: normal;
  }
}
</style>
